import { gql } from '@apollo/client';

export const ACCOUNT = gql`
  query getBillingInformation {
    account: accountData {
      id
      billingInformation {
        address
        city
        company
        country
        firstname
        lastname
        state
        zip
      }
    }
  }
`;
